import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import { withTranslation } from 'react-i18next';
import SmartCard from '../../../shared/components/SmartCard';
import { columnsDiscount } from './ColumnsGeneratorTitles';
import materialTableIcons from '../../../shared/utils/materialTableIcons';
import MaterialTableThemeProvider from '../../../shared/components/MaterialTableThemeProvider';

const ViewDiscount = (props) => {
  const { t, data } = props;

  return (
    <MaterialTableThemeProvider>
      <SmartCard>
        <div className="form__form-group">
          <MaterialTable
            icons={materialTableIcons}
            data={data}
            columns={columnsDiscount(t)}
            options={{
              paging: false,
              showTitle: false,
              search: false,
              toolbar: false,
              actionsColumnIndex: 8,
            }}
            localization={{
              body: {
                emptyDataSourceMessage: t('general.tables.no-data-to-display'),
              },
            }}
          />
        </div>
      </SmartCard>
    </MaterialTableThemeProvider>
  );
};

ViewDiscount.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)),
};

ViewDiscount.defaultProps = {
  data: [],
};

export default withTranslation('common')(ViewDiscount);
